module.exports = __webpack_public_path__ + "img/pudongxinqu.a1c8faf4.png";